<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter="24">
          <a-col  :md='6' :sm='8'>
            <a-form-item label="DisbursementDate" >
              <a-range-picker
                v-model="queryParam.time"
                format="YYYY-MM-DD"
                style="width: 200px;"/>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item label="Status">
              <a-select  style='width: 190px' allowClear v-model='queryParam.status'>
                <a-select-option value="-1" >All</a-select-option>
                <a-select-option value="00">Initialization</a-select-option>
                <a-select-option value="01">Success</a-select-option>
                <a-select-option value="02">Failed</a-select-option>
                <a-select-option value="03">Processing</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <!--<a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>-->
            </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-upload
                    name="file"
                    :multiple="true"
                    :action="'/api/web/webpublic/platform/import/importingSalaryExcel'"
                    :headers="getHeaders()"
                    :data="uploadDataParam"
                    @change="handleChangeUpload"
            >
              <a-button style='margin-left: 8px'> <a-icon type="upload" /> Upload Salary TemplateexcelFile</a-button>
            </a-upload>
          </a-col>
          <br/>
          <a-col>
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                              <a-button type="primary" @click="downLoadData(1)" icon="download"
                                        style="margin-left: 8px">Export Disbursement FailedexcelFile
                              </a-button>
                         </span>
            <span></span>
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                              <a-button type="primary" @click="downLoadData(2)" icon="download"
                                        style="margin-left: 8px">Export All ReconciliationexcelFile
                              </a-button>
                         </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        @change='handleTableChange'>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getPayoutList } from '@/webpublicapi/importSalary'
import { getHeaders } from '@/utils/request'
import moment from 'moment'
import exportFile from "@/webpublicapi/exportFile";

const I18N_KEY = {
  OASYSTEM: 'oaSystem.',
  FOLLOW: 'importSalary.'
}
export default {
  name: 'importSalary',
  components: {},
  data() {
    return {
      visdialog: false,
      I18N_KEY,
      visible: false,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      dataSourceTotal: [],
      departments: [],
      groupAll: [],
      normalConfigList: [],
      // Query conditions
      queryParam: {
        time: [],
        status:'',
      },
      loading: false,
      // Table header
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      uploadDataParam:{}
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'id',
          align: 'left',
          dataIndex: 'id'
        },
        {
          title:  'Name',
          align: 'center',
          dataIndex: 'names'
        },
        {
          title:  'Collection Account No.',
          align: 'center',
          dataIndex: 'accountNumber'
        },
        {
          title:  'Order No.',
          align: 'center',
          dataIndex: 'busNo'
        },
        {
          title:  'Amount',
          align: 'center',
          dataIndex: 'amount'
        },
        {
          title:  'Status',
          align: 'center',
          dataIndex: 'status',
          customRender: function (text) {
            if (text==='00') {
              return "Initializing"
            } else if (text === '01') {
              return "Success"
            } else if (text === '02') {
              return "Failed"
            } else if (text === '03') {
              return "Disbursement in "
            } 
          }
        },
        {  
          title:  'Created Time',
          align: 'center',
          dataIndex: 'createdTime',
          customRender: function (text) {
            return moment(text).format('YYYY-MM-DD HH:mm:ss');
          }
        },
        {
          title:  'Updated Time',
          align: 'center',
          dataIndex: 'updatedTime',
          customRender: function (text) {
            return moment(text).format('YYYY-MM-DD HH:mm:ss');
          }
        }

      ]
    }
  },
  created() {
    this.getTime();
    this.loadData(1)
  },
  methods: {
    getTime() {
      this.queryParam.time = [];
      var nowDate = new Date();
      this.queryParam.time[0]=moment(nowDate.setDate(nowDate.getDate() - 7));
      this.queryParam.time[1]=moment(new Date());

    },
    getHeaders() {
      return getHeaders();
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      var params = this.getQueryParams()// Query conditions
      if (!params.beginTime) {
        this.$message.error("Datecannot be empty");
        return;
      }
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true

      getPayoutList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },

    getQueryParams() {
      var param = this.queryParam;
      param.pageNum = this.form.pageNum;
      param.pageSize = this.form.pageSize;
      param.beginTime = (param.time && param.time.length) ? this.transformTime(param.time[0]) : undefined;
      param.endTime = (param.time && param.time.length) ? this.transformTime(param.time[1]) : undefined;

      return filterObj(param)
    },
    transformTime (time) {
      return time.format('YYYY-MM-DD')
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // Reset search box content
    searchReset() {
      queryParam.status = "";
      this.getTime();
    },
    handleChangeUpload(info) {
      //debugger;
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        if(info.file.response.code === 1000){
          //alert('handle success!');
          this.$message.success(`${info.file.name} file uploaded successfully`);
        } else {
          alert(info.file.response.msg);
        }
      } else if (info.file.status === 'error') {
        //this.$message.error(`${info.file.name} file upload failed.`);
        alert('system error!');
      }
    },
    downLoadData(flag) {
      var params = this.getQueryParams()// Query conditions
      var beginTime = params.beginTime;
      if (!beginTime) {
        alert('PleaseSelect date');
        return false;
      }
      const file = {
        fileUrl: '/api/web/webpublic/payChecking/exportSalaryFailExcel?startDate=' + params.beginTime + '&endDate=' +
                params.endTime + '&flag=' + flag,
        fileName: params.beginTime + '&' + params.endTime + '&' + flag +'.xlsx',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    }
    
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
